// COCO AI Assistant features that are built but not yet released.

/** "Build a report" (route /leafnet-bot/reports). While false, every entry point is hidden and the route redirects to /leafnet-bot. */
export const REPORTS_ENABLED = false;
